import { withCurrentParams } from 'actions/utils';
import { BROADCAST_STOP_RECORDINGS } from 'actions/Types';
import { BROADCAST_RECORDING_STOP } from 'store/eventConstants';

export default recordings => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, _, socket) => {
      const action = {
        type: BROADCAST_STOP_RECORDINGS,
        request: async apiClient => {
          const response = await apiClient.broadcast.stopRecordings(
            teamId,
            eventId,
            broadcastId,
            {
              recordings
            }
          );
          // notify other directors
          socket.emit(BROADCAST_RECORDING_STOP, { broadcastId });

          return response;
        }
      };
      dispatch(action);
    }
  );
};
